"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var timezone_styles_1 = require("./timezone.styles");
function Timezone(props) {
    return (React.createElement("div", { className: timezone_styles_1.timezone, id: "timezone" }, props.timezoneName !== undefined && (React.createElement(React.Fragment, null,
        React.createElement("span", { id: "timezone-abbreviation" }, props.timezoneShortName),
        " -",
        " ",
        React.createElement("span", { id: "timezone-name" }, props.timezoneLocalizedName)))));
}
exports.Timezone = Timezone;
